import { Text3D, useTexture } from '@react-three/drei'
import Seats from '../components/Seats'
import Image from '../components/Image'
import ProjectEntry from '../components/ProjectEntry'

const Blurb = ({...props}) => {
  // Content
  const header = "Projects"
  const project1 = {
    title: "Fairify | StormHacks 2021 Winner",
    blurb: "A user-friendly web-app which algorithmically evaluates the fair-trade practices of any company by compiling online \
community reviews, verifying fair trade certifications, web-scraping for relevant articles, and employing natural language processing/sentiment analysis.",
    link: "github.com/bri-yan/StormHacks",
    image: "./images/popcat-closed.png",
    url: "https://github.com/bri-yan/StormHacks"
  }
  const project2 = {
    title: "Jesture | nwHacks 2022 Finalist",
    link: "github.com/bri-yan/jesture",
    blurb: "A web-based American Sign Language learning platform which utilizes machine learning and computer vision to provide \
real-time lessons and feedback, verifying sign language correctness and identifying potential areas to improve.",
    image: "./images/popcat-closed.png",
    url: "https://github.com/bri-yan/jesture"
  }
  const project3 = {
    title: "Sentri | Pinnacle Hackathon 2021 Finalist",
    link: "devpost.com/software/sentri",
    blurb: "A crime-data driven route planer which employs FBI crime data to visualize crimes in the area on a responsive 3D \
map and determines the safest walking path from point A to point B by leveraging Google's Directions API.",
    image: "./images/popcat-closed.png",
    url: "https://devpost.com/software/sentri"
  }
  const project4 = {
    title: "Placeholder",
    blurb: "placeholder",
    link: "github.com/bri-yan/placeholder",
    image: "./images/popcat-closed.png",
    url: "https://github.com/bri-yan/placeholder"
  }

  // Images
  const img = useTexture("./images/popcat-open.png")

  // Details
  const projectStart = -5.75
  const projectSpacing = 5

  return (
    <group {...props}>
      
      {/* Header */}
      <Text3D font="./fonts/Lato_Regular.json" size={1.5} height={0.12} position={[3.25, 1.8, -7]} rotation={[-Math.PI / 2, 0, 0]}>
        {header}
      </Text3D>

      {/* Header Icon */}
      <Image map={img} args={[1.6, 1.6]} position={[12, 1.92, -7.75]} rotation={[-Math.PI / 2, 0, 0]} />

      {/* Projects */}
      <ProjectEntry title={project1.title} blurb={project1.blurb} link={project1.link} url={project1.url} image={project1.image}
      position={[3.25, 1.92, projectStart]} rotation={[-Math.PI / 2, 0, 0]} />

      <ProjectEntry title={project2.title} blurb={project2.blurb} link={project2.link} url={project2.url} image={project2.image}
      position={[3.25, 1.92, projectStart + projectSpacing]} rotation={[-Math.PI / 2, 0, 0]} offset={0.5}/>

      <ProjectEntry title={project3.title} blurb={project3.blurb} link={project3.link} url={project3.url} image={project3.image}
      position={[3.25, 1.92, projectStart + projectSpacing * 2]} rotation={[-Math.PI / 2, 0, 0]} offset={0.5}/>

      {/* <ProjectEntry title={project4.title} link={project4.link} url={project4.url}
      position={[3.25, 1.92, projectStart + projectSpacing * 3]} rotation={[-Math.PI / 2, 0, 0]} /> */}

    </group>
  )
}


const Projects = ({ models, color = 'white', seatColor = 'white', header, body, texture, ...props }) => (
  <group {...props}>
    <models.Cabin color={color} />
    <Seats models={models} seatColor={seatColor} />
    <Blurb />
  </group>
)

export default Projects
